import QuestionCard from '../components/QuesAndAns/QuestionCard';
import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import {useEffect} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import Alert from '@mui/material/Alert';
import {question, questionSingle} from '../mockData/question';

export default function PollSingle() {
  let [searchParams, setSearchParams] = useSearchParams()
  const {pollId} = useParams()
  console.log('searchParams', searchParams)
  console.log('pathParamspollId', pollId)
  const isSuccess = searchParams.get('success') === 'true'
  useEffect(() => {
    window.scrollTo(0, 0)
  })

  const questionDetail = question().find(quest => pollId === quest.questionType)

  return <>

    <CommonAppbar isMainPage={false} pageHeader={``}/>
    <>{isSuccess && <>
      <Alert severity="success">Successfully created &lt;<b>Question Type</b>&gt;</Alert>
    </>}</>
    <QuestionCard isSingle={true} quesAndAns={[questionDetail ? questionDetail : questionSingle()]}/>
  </>
}
